import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Survey_Create = BaseAnalyticsEvent.extend({
    name: z.literal("Survey_Create"),
    properties: z.object({
        from: z.enum([
            "scratch",
            "duplicate"
        ])
    })
});
export const Survey_Delete = BaseAnalyticsEvent.extend({
    name: z.literal("Survey_Delete")
});
export const Survey_ConnectPaywall = BaseAnalyticsEvent.extend({
    name: z.literal("Survey_ConnectPaywall"),
    properties: z.object({
        from: z.enum([
            "editor",
            "survey"
        ])
    })
});
export const Survey_DiscconnectPaywall = BaseAnalyticsEvent.extend({
    name: z.literal("Survey_DiscconnectPaywall")
});
export const Survey_ViewStats = BaseAnalyticsEvent.extend({
    name: z.literal("Survey_ViewStats"),
    properties: z.object({
        responses: z.enum([
            "overall",
            "other"
        ])
    })
});
